import { styled } from "styled-components";

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;
